import * as React from 'react';
import { ReactSVG } from 'react-svg';
import { Link } from 'react-router-dom'
import './index.css'
import cuentacorriente from '../assets/cuentacorriente.svg'
import devoluciones from '../assets/devoluciones.svg'
import distribuciondevoluciones from '../assets/distribucion.svg'
import suscripciones from '../assets/suscripciones.svg'
import suscripcionesaltasbajas from '../assets/suscripcionesaltasbajas.svg'
import pedidos from '../assets/pedidos.svg'
import registrarventa from '../assets/registrarventa.svg'
import tienda from '../assets/tienda.svg'
import clubparadaonline from '../assets/clubParadaOnline.svg'
import { version } from '../../package.json'
import novedades from '../assets/novedades.svg'
import urlServer from '../server';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import Spinner from '../components/spinner';
import { validarVencimientoToken } from "../localStorageManager";

const MySwal = withReactContent(Swal)
const versionActual = version.replace(/\./g, '')

export default class Index extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            cuentacorriente,
            devoluciones,
            distribuciondevoluciones,
            suscripciones,
            suscripcionesaltasbajas,
            pedidos,
            registrarventa,
            tienda,
            novedades,
            clubparadaonline,
            descripcionesNov: [],
            estaEnPerfil: false,
            cantidadPermisos: 0,
            altasBajasPendientes: 0
        }
    }
           
    listadoNovedades = async () => {
        const headers = {
            "Content-Type": 'application/json',
            "Accept": 'application/json',
            Authorization: 'Bearer ' + localStorage.token
        }

        const data = {
            NombreTienda: "TIENDA AGEA"
        }

        const url = urlServer + "/api/novedades/novedadesVigentes/listar"

        const respuesta = await fetch(url,{
            method: 'POST',
            redirect: 'manual',
            body: JSON.stringify(data),
            headers: headers
        })
        .then(response => response.json())
        .then(result => {
            validarVencimientoToken(result.message);
            this.setState({ descripcionesNov: result.rows })
        })
        .catch(error => {
            validarVencimientoToken(error.message); 
            console.log('error', error) 
        })

        return respuesta
    }

    listadoAltasBajasPendientes = async () => {
        const headers = {
            "Content-Type": 'application/json',
            "Accept": 'application/json',
            Authorization: 'Bearer ' + localStorage.token
        }

        const data = {
            puntoVentaId: JSON.parse(localStorage.infoToken).entidad_id,
            fecha: new Date().toISOString().slice(0, 10)
        }

        const url = urlServer + "/api/suscripciones/Novedades/Pendientes/Contar"

        await fetch(url, {
            method: 'POST',
            redirect: 'manual',
            body: JSON.stringify(data),
            headers: headers
        })
        .then(response => response.json())
        .then(result => {
            validarVencimientoToken(result.message);
            this.setState({ altasBajasPendientes: result.cantidad || 0 })
        })
        .catch(error => {
            validarVencimientoToken(error.message);
            console.log('error', error)
        })
    }

    renderNotifications() {
        const { descripcionesNov } = this.state

        return (
            <React.Fragment>
                {this.state.descripcionesNov ?
                   descripcionesNov.length === 0 ? null :  <span id='notification' className=""> {descripcionesNov.length} </span> 
                : null}
            </React.Fragment>
        )
    }

    componentDidMount() {
        this.listadoNovedades()
        this.listadoAltasBajasPendientes()
        this.props.setStateNoEstaEnPerfil()
    }

    getLinkIcon = (link) => {
        if (link.iconKey && this.state[link.iconKey]) {
            return this.state[link.iconKey]
        }

        return this.state[link.link.replace("/", "").replace("/", "").toLowerCase()]
    }

    renderIndex = () => {
        const { links } = this.props

        return (
            <React.Fragment>
                <div className="index-menu">
                    <div style={{display: 'grid', gridGap: '10px', gridTemplateColumns: "repeat(auto-fill, minmax(140px, 1fr))", justifyItems: 'center'}}>
                        {links ? (links.map((link, index) => {
                            if (!link) {
                                return null
                            }

                            return  <div key={index} className="index-menu-box d-flex align-items-center justify-content-center flex-column position-relative box-content" >
                                        {link.name === 'Novedades' ? this.renderNotifications() : ''}
                                        {link.name === 'Suscripciones Altas/Bajas' && this.state.altasBajasPendientes > 0 ? <span className="index-menu-badge">{this.state.altasBajasPendientes}</span> : null}
                                        <Link className={link.name === 'Novedades' && (this.state.descripcionesNov) ? (this.state.descripcionesNov.length !== 0 && !this.state.estaEnPerfil ? 'withNotif' : 'noNotif'): 'noNotif'}  onClick={() => {this.props.hideMenu(true)}} to={link.link}>
                                            <ReactSVG style={{color: '#8E95A5', width: '28px', height: '32px', position:'relative', left: '0', right: '0', bottom: '0px', margin: 'auto'}} src={this.getLinkIcon(link)}/>
                                            <span>
                                                {link.name}
                                            </span>
                                        </Link>
                                    </div>
                        }))
                        : null}
                    </div>
                </div>
                <div className="version mb-1" >v{version}</div>
            </React.Fragment>
            
        )
    }

    render(){
        const {loading} = this.state
        return (
            
            loading ? <div className="index"><Spinner style={{ fontSize: '8px' }} /></div>
                :
                <div className="index">
                    { this.renderIndex() }
                </div>
                )
    }
}